<div class="report-top-card box card-box m-b-0 p-b-sm">
  <div class="box-header">
    <h3>{{ 'REPORTS.report_selection' | translate }}
      <div class="pull-right">
        <button (click)="createNewReport()"
                class="btn btn-sm btn-fill-default m-r-xs"
                [attr.test-id]="'create-new-report-btn' | gpTestId: 'report-top-card'"
                [tooltip]="'FORMS.create_new_report' | translate"
                type="button">
          <i class="fa fa-light fa-file-circle-plus" aria-hidden="true"></i>
          {{ 'REPORTS.new_report' | translate }}
        </button>
        <button *ngIf="canSaveReport()"
                (click)="save()"
                class="btn btn-sm btn-outline-default m-r-xs"
                [attr.test-id]="'save-template-btn' | gpTestId: 'report-top-card'"
                type="button">
          <i class="fa fa-light fa-save" aria-hidden="true"></i>
          {{ 'FORMS.save' | translate }}
        </button>
      </div>
    </h3>
  </div>
  <div class="box-body p-b-0">
    <div class="row">
      <div class="col-md-12 p-b-xs">{{ 'REPORTS.report_template' | translate }}</div>
    </div>
    <div class="row p-b-sm">
      <div class="col-md-10 p-r-0">
        <gp-tree-select
          #templatesSelect
          [attr.test-id]="'reports-list' | gpTestId: 'report-top-card'"
          (elementSelected)="selectReport($event)"
          [tree]="reportsTree"
          [placeholder]="'REPORTS.select_your_report' | translate"
          [allowClear]="false"
          class="form-control"
          formControlName="fieldName"
          id="field"
          ngDefaultControl>
        </gp-tree-select>
      </div>
      <div class="col-md-1 p-x-0">
        <div class="dropdown pull-left m-t-n1"
             [class.open]="menuOpened"
             (click-outside)="menuOpened = false"
             *ngIf="show3dotsMenuOrUpdateReportModal()">
          <button class="btn btn-sm btn-outline" type="button" (click)="menuOpened = !opened">
            <span class="fa fa-light fa-ellipsis-v"></span>
          </button>
          <ul class="dropdown-menu" [attr.test-id]="'3-dots-menu' | gpTestId: 'report-top-card'">
            <li class="dropdown-item" (click)="openEditReportModal()">
              <i aria-hidden="true" class="fa fa-light fa-cog dropdown-icon"></i>
              <span>{{ 'TEMPLATE.settings' | translate }}</span>
            </li>
            <li *ngIf="!report.reportEntity.isStandard && (report.reportEntity.editingAllowed || isMyReport())"
                class="dropdown-item"
                (click)="openModalShare()">
              <i class="fa fa-light fa-share-square dropdown-icon"></i>
              <span>{{ 'REPORTS.share_report' | translate }}</span>
            </li>
            <li class="dropdown-item text-danger" (click)="deleteReport()">
              <i class="fa fa-light fa-trash-alt dropdown-icon"></i>
              <span>{{ 'FORMS.delete' | translate }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row p-b-sm">
      <div class="col-md-12">
        <button type="button"
                class="btn btn-sm btn-outline-default"
                [attr.test-id]="'add-fields-btn' | gpTestId: 'report-top-card'"
                [disabled]="!fieldsTree.length"
                (click)="addFieldsModal.open()">
          <i class="fa fa-light fa-list" aria-hidden="true"></i>
          {{ 'REPORTS.add_fields' | translate }}
        </button>
      </div>
    </div>
    <gp-report-time [report]="report"></gp-report-time>
  </div>
</div>

<gp-add-fields-modal #addFieldsModal
                     [fieldsTree]="fieldsTree"
                     [currentFilterCount]="report.filters.length"
                     [currentColumnCount]="report.columns.length"
                     [maxFilters]="MAX_FILTER_COUNT"
                     [maxColumns]="MAX_RESULT_COUNT"
                     [targets]="['filter', 'column', 'both']"
                     modalId="report-add-fields"
                     (fieldsAdded)="onFieldsAdded($event)">
</gp-add-fields-modal>

<!--Create report-->
<gp-modal gp-modal="create-report"
          [closable]="true"
          (closed)="reportModalCancelCallback()"
          [form]="true">
  <div class="gp-modal-title">
    {{isEditReport ? ('REPORTS.report_settings' | translate) + ': ' + currentReportTitle : ('REPORTS.new_report' | translate)}}
  </div>
  <div class="gp-modal-body">
    <form [formGroup]="editReportsForm">
      <div class="row m-b" *ngIf="this.reportTitleAlreadyExists">
        <div class="col-sm-12">
          <div class="alert alert-danger m-t-sm" role="alert">
            {{ reportTitleAlreadyExistsMessage }}
          </div>
        </div>
      </div>
      <div class="row m-b">
        <div class="col-sm-5">
          <label for="title">
            {{ 'REPORTS.name' | translate }}&nbsp;<span
            class="required">*</span>
          </label>
        </div>
        <div class="col-sm-7">
          <input type="text"
                 class="form-control"
                 id="title"
                 formControlName="title">
        </div>
      </div>
      <div class="row m-b">
        <div class="col-sm-5">
          <label for="mass-actions-enabled">
            {{ 'MENU.MASS_ACTIONS' | translate }}
          </label>
        </div>
        <div class="col-sm-5">
          <label class="ui-switch v-m ">
            <input type="checkbox"
                 id="mass-actions-enabled"
                 formControlName="massActionsEnabled">
            <em></em>
          </label>
        </div>
      </div>
      <div class="row m-b"
           gp-roles
           *ngIf="!isEditReport && hasAccessToStandardReport()">
        <div class="col-sm-5">
          <label for="isStandard">
            {{ 'REPORTS.Standard_report' | translate }}
          </label>
        </div>
        <div class="col-sm-5">
          <label class="ui-switch v-m ">
            <input type="checkbox"
                   id="isStandard"
                   formControlName="isStandard">
            <em></em>
          </label>
        </div>
      </div>
    </form>
  </div>
  <div class="gp-modal-footer">

    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button type="button"
                (click)="reportModalSubmitCallback()"
                class="btn btn-dark p-x-md"
                [disabled]="!editReportsForm.valid">
          {{ 'FORMS.save' | translate }}
        </button>
        <button type="button"
                class="btn btn-secondary p-x-md"
                (click)="reportModalCancelCallback()">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>

  </div>
</gp-modal>

<!--Share report-->
<gp-modal #shareReport *gp-modal-struct="'shareReport'" [closable]="true" size="sm">
  <div class="gp-modal-title" style="max-width: 90%">
    <h4 class="text-ellipsis">{{ 'REPORTS.share_report' | translate }}</h4>
  </div>
  <div class="gp-modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>{{ 'REPORTS.share_report_text' | translate}}</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 form-group user-selection--info">
        <gp-chips (removed)="removeUser($event)"
                  [(ngModel)]="selectedUserTags"
                  [displayBy]="'name'"
                  [identifyBy]="'id'"
                  [placeholder]="''">
          <gp-chips-option
            *ngFor="let option of selectedUserTags"
            [ngValue]="option">
          </gp-chips-option>
        </gp-chips>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 form-group">
        <ng-select (typed)="fetchUsersByKeyword($event)"
                   (checked)="selectUser($event)"
                   [multiItemName]="{single: 'user', plural: 'users'}"
                   [customEmptyText]="'SETTINGS.search_user_to_select'"
                   [items]="employeeSelectList"
                   [isMultiSelect]="true"
                   [placeholder]="'Select'"
                   [asyncAutoCompletion]="true"
                   [disabled]="selectedUserTags?.length >= MAX_USER_TAGS"
                   class="form-control">
        </ng-select>
        <i *ngIf="isEmployeesLoading" class="fa fa-light fa-spinner fa-spin"></i>
        <div class="user-selection-info">
          <ul class="error-list">
            <li *ngIf="!isEmployeesLoading && selectedUserTags?.length >= MAX_USER_TAGS">
              {{ 'REPORTS.max_users' | translate }}
            </li>
          </ul>
          <span
            class="text-muted">{{ 'SETTINGS.user_selected_msg' | translate:{count: selectedUserTags.length} }}
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        {{'REPORTS.allow_edit' | translate}}
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="checkbox">
          <input type="radio" [value]="true" name="allow_edit" [(ngModel)]="report.reportEntity.editingAllowed">
          {{ 'FORM_GENERATOR.MODALS.BUTTONS.yes' | translate }}
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="checkbox">
          <input type="radio" [value]="false" name="allow_edit" [(ngModel)]="report.reportEntity.editingAllowed">
          {{ 'FORM_GENERATOR.MODALS.BUTTONS.cancel' | translate }}
        </label>
      </div>
    </div>
    <div>
      <div class="row m-t-md">
        <div class="col-md-push-10">
          <label class="ui-switch v-m">
            <input type="checkbox" [(ngModel)]="report.reportEntity.isPublic">
            <em></em>
          </label>
          {{ 'REPORTS.public_report' | translate }}
          <div class="col-md-12 row m-t-sm text-small">
            {{'REPORTS.public_report_text' | translate}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="gp-modal-footer">
    <button class="btn btn-dark p-x-md"
            [disabled]="isSaveDisabled()"
            (click)="shareTemplate(); closeModal(shareReport)">
      {{ 'FORMS.save' | translate }}
    </button>
    <button type="button"
            class="btn btn-secondary p-x-md"
            (click)="closeModal(shareReport)">
      {{ 'FORMS.cancel' | translate }}
    </button>
  </div>
</gp-modal>

